export const APP_INTENTION = {
  global: 'global',
  private: 'private',
  emptyString: '',
} as const;
export const BACKEND_APP_INTENTION = {
  ...APP_INTENTION,
  evaluating: 'evaluating',
};
